import Swiper from 'swiper/bundle';

export default function initSwiperTimeline() {
    const timelines = document.querySelectorAll('.block-timeline');

    timelines.forEach((timeline) => {
        const yearsContainer = timeline.querySelector('.swiperTimelineYears');
        const contentsContainer = timeline.querySelector('.swiperTimelineContents');

        if (yearsContainer && contentsContainer) {
            const swiperTimeLineYear = new Swiper(yearsContainer, {
                slidesPerView: 'auto',
                spaceBetween: 60,
                breakpoints: {
                    1200: {
                        spaceBetween: 120,
                    },
                },
                freeMode: true,
                watchSlidesProgress: true,
                allowTouchMove: true,
                simulateTouch: true,
                slideToClickedSlide: true,
                autoScrollOffset: 1,
            });

            const swiperTimeLineContent = new Swiper(contentsContainer, {
                spaceBetween: 60,
                autoHeight: true,
                breakpoints: {
                    1200: {
                        spaceBetween: 120,
                    },
                    1400: {
                        spaceBetween: 180,
                    },
                },
                navigation: {
                    nextEl: timeline.querySelector(".swiper-next"),
                    prevEl: timeline.querySelector(".swiper-prev"),
                },
                thumbs: {
                    swiper: swiperTimeLineYear,
                },
                allowTouchMove: true,
                simulateTouch: true,
            });

            swiperTimeLineContent.on('slideChange', () => {
                const activeIndex = swiperTimeLineContent.activeIndex;
                swiperTimeLineYear.slideTo(activeIndex);
            });
        }
    });
}
